import React from "react";
import Divider from "@mui/material/Divider";
import styles from "./horizontalDivider.module.scss";
const HorizontalDivider = ({ id, }) => {
    return React.createElement(Divider, { id: id, className: styles.divider });
};
export default HorizontalDivider;
//# sourceMappingURL=HorizontalDivider.js.map